import { Component } from "react";
import styles from './dropdown-input.module.scss'
import Dropdown from "../../ui/dropdown/dropdown";

export interface DropdownInputValueChangeEvent {
    inputValue: any;
    dropdownValue: any;
}

interface DropdownInputComponentProps {
    label: string;
    /** UXFU2-01: the name when `label` is empty (the subgroup label the caller draws itself). Not rendered. */
    ariaLabel?: string;
    values: any[];
    inputValue: any;
    dropdownValue: any;
    valueFormatter: (a) => string
    valueChanged: (a: DropdownInputValueChangeEvent) => void
}

interface DropdownInputComponentState {
    inputValue: any;
    dropdownValue: any;
    prevInputValue: any;
    prevDropdownValue: any;
}

export class DropdownInputComponent extends Component<DropdownInputComponentProps, DropdownInputComponentState> {

    state: Readonly<DropdownInputComponentState> = {
        inputValue: this.props.inputValue,
        dropdownValue: this.props.dropdownValue,
        prevInputValue: this.props.inputValue,
        prevDropdownValue: this.props.dropdownValue
    };
    constructor(props) {
        super(props)
    }

    static getDerivedStateFromProps(props: DropdownInputComponentProps, state: DropdownInputComponentState) {
        const newState: any = {};
        let changed = false;
        if (props.inputValue !== state.prevInputValue) {
            newState.inputValue = props.inputValue;
            newState.prevInputValue = props.inputValue;
            changed = true;
        }
        if (props.dropdownValue !== state.prevDropdownValue) {
            newState.dropdownValue = props.dropdownValue;
            newState.prevDropdownValue = props.dropdownValue;
            changed = true;
        }
        return changed ? newState : null;
    }

    inputChanged(e) {
        this.setState({
            inputValue: e.target.value
        });
        this.props.valueChanged({
            inputValue: e.target.value,
            dropdownValue: this.state.dropdownValue
        });
    }

    dropdownValueChanged(e) {
        this.setState({
            dropdownValue: e
        });
        this.props.valueChanged({
            inputValue: this.state.inputValue,
            dropdownValue: e
        });
    }

    render() {
        // Two unit-label populations exist site-wide and they need opposite
        // geometry: short units (MB, Mbps, Pixels, Seconds) must NEVER
        // truncate, while the 11+-char labels ("Percent (%)", the trim
        // widgets' "HH:MM:SS.sss") must be allowed to ellipsize on a narrow
        // row or they push the caret outside the card. The split keys on the
        // SELECTED label, not the widget's option list — a trim row showing
        // "Seconds" needs the no-truncate branch; the wide branch applies
        // only while a wide label is actually displayed.
        const selectedLabel = String((this.props.dropdownValue as any)?.name ?? '');
        const wideUnit = selectedLabel.length > 8;
        return <div className={`${styles['container']} ${wideUnit ? styles['wide-units'] : ''}`}>
            {
                this.props.label && <div className={`${styles['label']} text-flex-vertical-center`}>
                    {this.props.label}
                </div>
            }
            <div className={`${styles['input-with-dropdown']} x-input-group input-group-sm`}>
                <input className="form-control"
                    aria-label={this.props.label || this.props.ariaLabel || undefined}
                    onInput={e => this.inputChanged(e)}
                    type={"number"}
                    value={this.state.inputValue} />
                <div className={`${styles['input-group-append']} input-group-append`} id="button-addon4">
                    <Dropdown
                        firstBtnStyles={{ borderRadius: '0px' }}
                        values={this.props.values}
                        initialValue={this.props.dropdownValue}
                        valueFormatter={a => this.props.valueFormatter(a)}
                        hasTooltip={(a) => false}
                        getTooltip={(a) => null}
                        onSelect={(value) => this.dropdownValueChanged(value)}
                        label={null}
                        ariaLabel={this.props.label || this.props.ariaLabel || undefined}
                    ></Dropdown>
                </div>
            </div>
        </div>
    }
}